<script setup lang="ts">
import { Gift, Target, Ticket } from 'lucide-vue-next'
import type { Component } from 'vue'

import PanelGroup from '../PanelGroup.vue'
import { LOYALTY_BLOCKS, type LoyaltyBlockId } from '../../lib/brandAppContract'
import useBrandAppConfig from '../../composables/useBrandAppConfig'
import OrderedSubsetList from '../OrderedSubsetList.vue'

defineProps<{ title?: string }>()

const { loyaltyBlocks, setLoyaltyBlocks } = useBrandAppConfig()

const { t } = useI18n()

const ICONS: Record<LoyaltyBlockId, Component> = { unlocked: Ticket, missions: Target, catalog: Gift }

const items = computed(() =>
  LOYALTY_BLOCKS.map((block) => ({ id: block.id, label: block.label, icon: ICONS[block.id] }))
)
</script>

<template>
  <PanelGroup :title="title">
    <div class="flex flex-col gap-3">
      <OrderedSubsetList
        :items="items"
        :model-value="loyaltyBlocks"
        :order="loyaltyBlocks"
        :allow-hiding="false"
        @update:order="setLoyaltyBlocks"
      />
      <p class="text-muted-foreground text-xs">
        {{ t('pages.loyaltySupports.webapp.editor.structure.loyalty.hint') }}
      </p>
    </div>
  </PanelGroup>
</template>
